import {Component, Inject, OnInit} from '@angular/core';
import {OidcSecurityService} from 'angular-auth-oidc-client';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import {ApiService} from './shared/services/api.service';

import {InternalService} from './shared/services/internal.service';
import {TranslateService} from '@ngx-translate/core';
import {ActivatedRoute, Router} from '@angular/router';
import {CookieService} from "ngx-cookie-service";
import {Title} from "@angular/platform-browser";


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
 // title = 'Elimedi Admin panel';

  constructor(
    private apiService: ApiService,
    private title: Title,
    private cookieService: CookieService,
    public internalService: InternalService,
    private route: ActivatedRoute,
    private router: Router,
    public translete: TranslateService,
    public oidcSecurityService: OidcSecurityService, public http: HttpClient,) {
  }


  ngOnInit() {
    // this.router.events.subscribe((event: any) => {
    //   console.log('++++++++++++++++++++++++',event)
    // })


    this.apiService.apiCall('get','/api/Account/RegisterConfirm',{}).subscribe((response: any) => {
      this.cookieService.set('fullName', response.res.name);
      this.cookieService.set('currentUserRoles', JSON.stringify(response.res.role));
      let rolesArray = JSON.parse(this.cookieService.get('currentUserRoles'));
      // console.log('roless--------',rolesArray)
    })

    if (this.cookieService.get('dir') == 'rtl' || this.cookieService.get('dir') == null || !this.cookieService.get('dir')) {
      this.apiService.currentDirection = this.cookieService.get('dir');
      this.changeLang('fa-ir');
      this.title.setTitle('ایلایمدی');
      this.cookieService.set('lang', '1');
    } else {
      this.apiService.currentDirection = this.cookieService.get('dir');
      this.changeLang('en-us');
      this.title.setTitle('Elimedi');
    }


  }


  changeLang(language) {
    this.internalService.changeLang(language, 0);
  }

}
